// Phones load the development UI over LAN. Its origin is not a production
// chat origin, so the device proxy forwards the handshake to the existing EC2.
export function chatEndpoint(endpoint: string, page = window.location.href, development = process.env.NODE_ENV === 'development') {
  const target = new URL(endpoint), origin = new URL(page);
  if (development && origin.protocol === 'http:' && target.protocol === 'ws:' &&
      ['localhost', '127.0.0.1', '[::1]'].includes(target.hostname) && target.port === '3030' && target.pathname === '/__local-chat' &&
      Array.from(target.searchParams.entries()).every(([key, value]) => key === 'encoding' && value === 'gzip')) {
    target.hostname = origin.hostname;
    return target.href;
  }
  if (target.protocol !== 'wss:') throw new Error('채팅 서버 주소를 확인해주세요.');
  if (development && origin.protocol === 'http:' && !['localhost', '127.0.0.1', '[::1]'].includes(origin.hostname)) {
    return `ws://${origin.host}/__broadcast-chat`;
  }
  return endpoint;
}
